var _rect, _path, _ellipse, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImagePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 4.8,
    fill: "#E2E6EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5195 35.5199C27.5195 33.2224 29.382 31.3599 31.6795 31.3599H64.3195C66.617 31.3599 68.4795 33.2224 68.4795 35.5199V61.1199C68.4795 63.4174 66.617 65.2799 64.3195 65.2799H31.6795C29.382 65.2799 27.5195 63.4174 27.5195 61.1199V35.5199ZM31.6795 33.2799C30.4424 33.2799 29.4395 34.2827 29.4395 35.5199V61.1199C29.4395 62.357 30.4424 63.3599 31.6795 63.3599H64.3195C65.5566 63.3599 66.5595 62.357 66.5595 61.1199V35.5199C66.5595 34.2827 65.5566 33.2799 64.3195 33.2799H31.6795Z",
    fill: "#B2B9C4"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.119,
    cy: 40.3197,
    rx: 4.16,
    ry: 4.16,
    fill: "#B2B9C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.959 57.9197V56.0224C32.959 55.598 33.1276 55.1911 33.4276 54.891L38.6002 49.7184C39.2041 49.1145 40.1759 49.0914 40.8079 49.6659L42.0859 50.8278C42.7114 51.3964 43.6714 51.3804 44.2775 50.7911L53.5878 41.7394C54.2151 41.1295 55.2159 41.1366 55.8345 41.7552L63.2104 49.131C63.5104 49.4311 63.679 49.838 63.679 50.2624V57.9196C63.679 58.8033 62.9626 59.5196 62.079 59.5196H34.559C33.6753 59.5196 32.959 58.8033 32.959 57.9197Z",
    fill: "#B2B9C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlaceholder);
export default __webpack_public_path__ + "static/media/image-placeholder.6332ce06a1d295ecaea0b8f515b6eb0c.svg";
export { ForwardRef as ReactComponent };